export default {
      id: "renovation-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#renovation-usage",
      toString: function () {
        return this.url;
      }
    }